@import "../skeleton/skeleton.scss";

:host {
    --wcs-skeleton-circle-border-radius: var(--wcs-semantic-border-radius-full);

    aspect-ratio: 1/1;
    border-radius: var(--wcs-skeleton-circle-border-radius);
}
